import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import InfoModal from '../InfoModal';
import ContextualHelpButton from './ContextualHelpButton';
const ContextualHelpModal = ({ modalContent, contentType }) => {
    return (_jsxs("div", Object.assign({ className: "modal-container contextual-help", "data-testid": "contextual-help-modal" }, { children: [_jsx(ContextualHelpButton, { modalType: "contextual-help-modal", contentType: contentType }), _jsx(InfoModal, { modalContent: modalContent, modalType: "contextual-help-modal" })] })));
};
export default ContextualHelpModal;
